




















































































































































































//import Vue from "vue";
import { mapState } from "vuex";
import Token from "@/components/Token.vue";
import ColorsGrid from "@/components/ColorsGrid.vue";

export default {
  name: "Home",
  components: { Token, ColorsGrid },
  mounted: async function() {
    const t = (this as any);
    await t.$store.dispatch("initialize");
    t.fetchMarketData();
  },
  data: () => ({
    floor: {},
    cards: [
      {
        lines: [
          "Vast Posibilities",
          "A State of the Art Collaborative On-Chain Generative Algorithm",
          "Choose from hundreds of googols of possible outcomes",
          "Art Thats Forever",
          "The Immutible & Decentralized Perpetual Renderer",
          "That means art thats accesible forever and fully owned by you",
          "Animations",
          "Animation straight from the on chain renderer",
          "Static and animated versions of each token art",
          "Creativity + Suprise",
          "Tweak the sliders, explore the posibilities",
          "You never know what you will get, thanks to a dash of RNG on minting"
        ]
      }
    ]
  }),
  computed: {
    ...mapState({
        animationTitles: "animationTitles",
        schemeTitles: "schemeTitles",
        openseaTokenURL: "openseaTokenURL"
    }),
  },
  methods: {
    fetchMarketData() {
      (this as any).$http
        .get('https://tinybox.shop/.netlify/functions/market-data')
        .then((response: any) => {
          console.log(response.data)
          const openSeaFloor = response.data.openSea.floorPrice
          const looksRareFloor = response.data.looksRare.floorPrice
          const trueFloor = openSeaFloor <= looksRareFloor ? openSeaFloor : looksRareFloor
          this.floor = {...response.data, "trueFloor": trueFloor}
        })
        .catch((error: any) => {
          console.error("Error fetching market data:", error);
        });
    },
  }
};
